// 公共样式，涉及组件：涉及组件：柱状图，折线图，饼图，雷达图，3D饼图、词云、水位图、仪表盘、地图、3d地图、象形柱图
// 公共样式：背景，边框，边距
// 对应公共样式设置文件：chart-common-options-setting-1.vue
export default {
  mixins: [],
  props: {
    options: null,
    myid: {
      type: Object,
      default: null
    }
  },
  data() {
    return {

    }
  },
  watch: {},
  computed: {
    ids() {
      return this.myid
    },
    themeColor() {
      return isSsrPage() ? this.$store.state.page.themeColor : this.$store.state[this.request_prefix].page.themeColor
    },
    getChartCommonStyle() {
      if (this.options) {
        let borderW = "", borderColor = "transparent"
        this.checkAndSetVal(this.options, "borderWidth", "borderWidth", 1)
        if (Array.isArray(this.options.borderWidth)) {
          this.options.borderWidth.forEach(item => [(borderW += ` ${item}px`)])
        } else {
          borderW += ` ${this.options.borderWidth}px`
        }
        // if(this.options.borderIsThemeColor){
        //   borderColor = this.themeColor
        // }else if(this.options.borderColor){
        //   borderColor = this.options.borderColor.color ? this.options.borderColor.color : this.options.borderColor
        // }
        borderColor = this.$parseColor(this.options.borderColor, {
          isThemeColor: this.options.borderIsThemeColor
        }) || "transparent"
        let paddingStr = {}
        //  不加边距：地图、雷达、3d地图 /有坐标轴的柱状，折线，
        let typeN = ["cxRadar","cxRealMap", "cxMap3D"]
        if(typeN.indexOf(this.options.innerElement) === -1 && !this.hasProperty(this.options, 'chartOption.grid')){
          paddingStr = {
            padding: this.getPaddingStyle
          }
        }
        return {
          ...this.bgStyle,
          "border-style": this.options.borderStyle || "solid",
          "border-color": borderColor,
          "border-width": this.options.showBorder !== false ? borderW : 0,
            ...paddingStr
        }
      } else return null
    },
    bgStyle() {
      let containerBg = {
        backgroundImage: ""
      }
      let curBackground = this.options.background
      if (
          !curBackground ||
          !Array.isArray(curBackground) ||
          (Array.isArray(curBackground) && curBackground.length === 0)
      ) {
        curBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: this.options.hasOwnProperty("bgColorIsThemeColor") ? this.options.bgColorIsThemeColor : false,
            color: this.options.bgColor
          }
        ]
      }
      curBackground.forEach(bg => {
        switch (bg.type) {
          case "img":
            let dot1 = containerBg.backgroundImage.length > 0 ? "," : ""
            containerBg.backgroundImage += `${dot1}url(${bg.imgUrl})`
            containerBg.backgroundSize = containerBg.backgroundSize
                ? `${containerBg.backgroundSize},${bg.clipSize}`
                : `${bg.clipSize}`
            containerBg.backgroundPosition = containerBg.backgroundPosition
                ? `${containerBg.backgroundPosition},${bg.alignType}`
                : `${bg.alignType}`
            containerBg.backgroundRepeat = containerBg.backgroundRepeat
                ? `${containerBg.backgroundRepeat},${bg.repeatType}`
                : `${bg.repeatType}`
            break
          case "color":
            containerBg.backgroundColor = this.$parseColor(bg)
            // containerBg.backgroundColor = bg.isThemeColor
            //     ? this.$store.state[this.request_prefix].page.themeColor
            //     : bg.color
            break
          case "linearGradient":
            let tmp = []
            if (bg.data.stops.length > 0) {
              bg.data.stops.forEach(item => {
                tmp.push(item[0] + " " + item[1] * 100 + "%")
              })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              // containerBg.backgroundImage += dot + "linear-gradient(" + bg.data.angle + "deg," + tmp.join(",") + ")"
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              containerBg.backgroundSize = containerBg.backgroundSize ? `${containerBg.backgroundSize},auto` : `auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition
                  ? `${containerBg.backgroundPosition},center`
                  : `center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat
                  ? `${containerBg.backgroundRepeat},no-repeat`
                  : `no-repeat`
            }
            break
          case "radialGradient":
            let radialTmp = []
            if (bg.data.stops.length > 0) {
              bg.data.stops.forEach(item => {
                radialTmp.push(item[0] + " " + item[1] * 100 + "%")
              })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              // containerBg.backgroundImage +=
              //     dot + "radial-gradient(at " + bg.data.siteX + "% " + bg.data.siteY + "%," + radialTmp.join(",") + ")"
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              containerBg.backgroundSize = containerBg.backgroundSize ? `${containerBg.backgroundSize},auto` : `auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition
                  ? `${containerBg.backgroundPosition},center`
                  : `center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat
                  ? `${containerBg.backgroundRepeat},no-repeat`
                  : `no-repeat`
            }
            break
          default:
        }
      })
      return containerBg
    },
    getPaddingStyle() {
      let padding1 = this.options.padding
      let paddingTypeFlag = this.options.paddingTypeFlag
      let paddingTop = this.options.paddingTop
      let paddingRight = this.options.paddingRight
      let paddingBottom = this.options.paddingBottom
      let paddingLeft = this.options.paddingLeft
      let padding = `${padding1}px`
      if (paddingTypeFlag === 2) {
        padding = `${paddingTop}px ${paddingRight}px ${paddingBottom}px ${paddingLeft}px`
      }
      return padding
    },
  },
  mounted() {},
  beforeDestroy() {},
  methods: {
    checkAndSetVal(opt, key, optname, val) {
      //兼容为NaN或没有的数值数据
      if (!opt.hasOwnProperty(key) || opt[key] !== opt[key] || opt[key] === null || opt[key] === undefined) {
        this.$changeOptionsEV(val, optname, false, null, this.myid)
        return val
      }
    },
  }
}
